<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <attachment-popup></attachment-popup>
        <v-expansion-panel>
          <v-expansion-panel-content
          expand-icon="add" subheader v-model="addNewCardCategoryPanel">
            <div slot="header">Add New Card Category</div>
            <v-card>
              <v-form ref="addNewForm" lazy-validation>
                <v-container class="pa-3">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="addNewForm.name"
                        prepend-icon="local_offer"
                        :rules="nameRules"
                        label="Category Name"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-textarea
                          v-model="addNewForm.description"
                          prepend-icon="note"
                          name="description"
                          label="Category Description"
                          required
                          :rules="descriptionRules"
                          validate-on-blur
                          type="text">
                          </v-textarea>
                      </v-flex>
                      <v-flex xs12>
                          <v-text-field
                            v-model="addNewForm.image_url"
                            label="Category Image URL"
                            prepend-icon="add_a_photo"
                            required
                          ></v-text-field>
                          <div class="image" v-if="addNewForm.image_url">
                              <img :src="addNewForm.image_url" alt=""/>
                            </div>
                            <v-btn
                              color="accent"
                              class="mx-0"
                              @click="selectImage('add')"
                            >
                              Select image
                            </v-btn>
                        </v-flex>
                      <v-flex xs12>
                        <v-switch
                        prepend-icon="lock"
                        label="Draft / Publish"
                        v-model="addNewForm.status"
                      ></v-switch>               
                      </v-flex>
                      <v-flex xs12>
                        <v-select :items="occasionList" 
                          prepend-icon="card_membership"
                          v-model="addNewForm.occasion_id" 
                          :rules="requiredRules"
                          label="Occasions"
                          validate-on-blur
                          item-value="value" >
                         </v-select>           
                      </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-spacer></v-spacer>
                    <v-btn
                     @click.prevent="addNewCardCategory()"
                     color="accent"
                    >
                      Add New Category <v-icon right dark size="16">play_arrow</v-icon>
                    </v-btn>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <v-flex xs12>
        <v-card flat tile class="elevation-2">
            <v-card v-if="cardCategoriesListError" key="occasionListErrorYes" class="pa-3">
              {{ cardCategoriesListErrorMessage }}
            </v-card>
          <v-card-title class="py-3 px-4">
                <v-layout row wrap>
                    <v-flex sm12 md4 lg4 left>
                       <v-subheader> All Card Categories</v-subheader>
                    </v-flex>
                    <v-flex sm12 md4 lg4>
                        <v-text-field
                        @input="filterByName"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                     <v-flex sm12 md4 lg4>
                        <v-select :items="occasionList"
                        v-model="filters.occasion_id"
                        label="Search by Occasions"
                        @change="filterByOccasion"
                        item-value="value">
                      </v-select>  
                    </v-flex>
                </v-layout>
          </v-card-title>
          <v-data-table
            v-if="$vuetify.breakpoint.smAndUp"
            :headers="headers"
            :items="allCardCategories"
            class="pa-3 tabulardata"
            :search="filters"
            :custom-filter="customFilter"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <img v-if="props.item.image_url" class="list-img" :src="props.item.image_url" :alt="props.item.name">
                <img v-else class="list-img" src="https://via.placeholder.com/600x350" :alt="props.item.name">
              </td> 
              <td class="text-xs-left">
                <router-link :to="{ name: 'Cards', params: { card_category_id: props.item.id } }">{{ props.item.name }}</router-link>
              </td>
              <td class="text-xs-left">{{ props.item.description }}</td>
              <td class="text-xs-left">{{ changeBooltoStr(props.item.status) }}</td>
              <td class="text-xs-left">{{ changeOccasionIdtoName(props.item.occasion_id) }}</td>
              <td class="text-xs-center">
                  <v-btn 
                  @click.prevent="updateCardCategoryPopup(props.item)"
                  color="accent">
                    <v-icon left dark size="16">edit</v-icon> EDIT
                  </v-btn>
                  <v-btn
                  color="primary" @click.prevent="deleteCardCategory(props.item)">
                    <v-icon left dark size="16">delete_forever</v-icon> DELETE
                  </v-btn>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
          <v-data-iterator
            v-else
            :items="allCardCategories"
            content-tag="v-layout"
            row
            wrap
            :search="search"
            class="pa-3"
          >
            <v-flex
              slot="item"
              slot-scope="props"
              xs12
              sm6
              md4
              lg3
            >
              <v-card-title>
                <img v-if="props.item.image_url" class="list-img" :src="props.item.image_url" :alt="props.item.name">
                <img v-else class="list-img" src="https://via.placeholder.com/600x350" :alt="props.item.name">
                <h4>{{ props.item.name }}</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.description }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.status }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.occasion_id }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-data-iterator>
        </v-card>
      </v-flex>
    </v-layout>

      <v-layout row justify-center>
            <v-dialog v-model="updateDialog" persistent max-width="600px">  
              <v-card>
                  <v-card-title color="primary" background-color="#db563f" class="display-1">
                   UPDATE CATEGORY
                  </v-card-title>
                  <v-form ref="updateForm" lazy-validation>
                    <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                        <v-text-field
                          v-model="updateForm.name"
                          prepend-icon="local_offer"
                          :rules="nameRules"
                          label="Category Name"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12>
                          <v-textarea
                            v-model="updateForm.description"
                            prepend-icon="note"
                            name="description"
                            label="Category Description"
                            required
                            :rules="descriptionRules"
                            validate-on-blur
                            type="text">
                            </v-textarea>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field
                              v-model="updateForm.image_url"
                              label="Category Image URL"
                              prepend-icon="add_a_photo"
                              required
                            ></v-text-field>
                            <div class="image" v-if="updateForm.image_url">
                                <img :src="updateForm.image_url" alt=""/>
                              </div>
                            <v-btn
                              color="accent"
                              class="mx-0"
                              @click="selectImage('update')"
                            >
                              Select image
                            </v-btn>
                        </v-flex>
                        
                        <v-flex xs12>
                          <v-switch
                            prepend-icon="lock"
                            label="Draft / Publish"
                            v-model="updateForm.status"
                          ></v-switch>           
                        </v-flex>

                        <v-flex xs12>
                          <v-select :items="occasionList" 
                            prepend-icon="card_giftcard"
                            v-model="updateForm.occasion_id" 
                            :rules="requiredRules"
                            label="Occasions"
                            validate-on-blur
                            item-value="value">
                          </v-select>           
                        </v-flex>

                      </v-layout>
                    </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error dark" @click.prevent="closeUpdateDialog()"><v-icon left dark size="16">close</v-icon> CANCEL</v-btn>
                  <v-btn color="accent dark" @click.prevent="updateCardCategory()">UPDATE <v-icon right dark size="16">play_arrow</v-icon></v-btn>
                  </v-card-actions>
              </v-card>
            </v-dialog>
      </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import Env from "../environment";
import { mapActions, mapGetters } from 'vuex'
import AuthApi from './controllers/AuthApi';

export default {
  name: "CardCategories",
  props: {
    msg: String
  },
  data: () => ({
    search: '',
    filters: {
      name: '',
      occasion_id: ''
    },
    occasionList: [
      {
        text: 'Select Occasion',
        value: ''
      },
    ],
    updateDialog: false,
    cardCategoriesListError: false,
    cardCategoriesListErrorMessage: "",
    addNewCardCategoryPanel: false,
    headers: [
      { text: 'Thumbnail', value: "image_url", sortable: false, },
      { text: 'Name', value: 'name' },
      { text: 'Description', value: 'description', sortable: false, },
      { text: 'Status', value: 'status' },
      { text: 'Occasion', value: 'occasion_id' },
      { text: "Actions", value: "" , align: 'center', sortable: false, },
    ],
    addNewForm: {
      name: '',
      description: '',
      image_url: '',
      status: 0,
      occasion_id: null
    },
    updateForm: {
      id: '',
      name: '',
      description: '',
      image_url: '',
      status: 0,
      occasion_id: null
    },
    nullRules: [v => v != "" || "Field is required"],
    requiredRules: [v => !!v || "Field is required"],
    nameRules: [v => !!v || "Name is required"],
    dateRules: [v => !!v || "Date is required"],
    descriptionRules: [v => !!v || "Description is required"],
    urlRules: [
      v => !!v || "Url is required",
      v =>
        /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(
          v
        ) || "Url must be valid"
    ]
  }),
  computed: {
    allCardCategories() {
      return this.$store.getters.getCardCategoriesList;
    },
    attachmentData() {
      return this.$store.getters.getAttachmentPopupData;
    }, 
  },
  watch: {
    attachmentData: function (val) {
       let attachmentLocation = this.$store.getters.getAttachmentLocation;
       let attachmentData = val;
      if( attachmentLocation == 'add') {
        this.addNewForm.image_url = attachmentData.url
      } else if(attachmentLocation == 'update'){
        this.updateForm.image_url = attachmentData.url
      }
    },
    '$route.params.occasion_id': function(val) {
      if(!val){
        this.filterByOccasion('')
      }
    },
  }, 
  created() {
   // this.$emit("load");
    this.init();
  },
  mounted() {
    const self = this;
    const occasionListMap = this.$store.getters.getOccasions;
    occasionListMap.map(item => {
      self.occasionList.push({
        text: item.name,
        value: item.id
      });
    });

    // If occasion id is passed in route, assign category 
    if( this.$route.params.occasion_id ){
      this.filterByOccasion(this.$route.params.occasion_id)
    }
  },
  methods: {
    /**
     * To get card categories and store it
     * @function
     * @returns {undefined}
     */
    init() {
      AuthApi.getApi(`${Env.giftcard_url}/api/card_category`)
        .then(res => {
          const cardCategoriesList = res.data.payload.data;
          this.$store.dispatch("SET_CARD_CATEGORIES_LIST", cardCategoriesList);
        })
        .then(() => {
          this.$emit("loadEnd");
        })
        .catch(err => {
          if (err.response.data.declaration === "auth_token_needs_refresh") {
            this.$emit("expire");
          } else if (err.response.data.declaration === "invalid_business") {
            this.cardCategoriesListError = true;
            this.cardCategoriesListErrorMessage =
              err.response.data.payload.message;
            this.$emit("loadEnd");
          } else {
            console.log(err);
          }
        });
    },
    /**
     * To add new cart category accepts addNewForm values
     * @function
     * @returns {undefined}
     */
    addNewCardCategory() {
      if (this.$refs["addNewForm"].validate()) {
        this.$emit("showSpinner");
        AuthApi.postApi(`${Env.giftcard_url}/api/card_category`, this.addNewForm)
        .then(() => {
          // Reset form keys
          for (var key in this.addNewForm) {
            this.addNewForm[key] = '';
          }
          // Close panel
          this.addNewCardCategoryPanel = false;
          this.$emit('hideSpinner');
          //Add Alert message
          this.snackbar({
            text: 'Successfully Added.',
            timeout: 5000,
            open: true
          })
          // Fetch list and send it to store
          this.init();
        })
        .catch((err) => {
          this.snackbar({
            text: err.response.data.payload.message,
            timeout: 5000,
            open: true
          })
        });
      }
    },

    /**
     * To popup update dialog box
     * @function
     * @returns {undefined}
     */
    updateCardCategoryPopup(obj) {
      this.updateDialog = true;
      // Assign values
      for (let key in this.updateForm) {
        this.updateForm[key] = obj[key];
      }
    },

    /**
     * To update card category depeding on updateForm fields
     * @function
     * @returns {undefined}
     */
    updateCardCategory() {
      if (this.$refs["updateForm"].validate()) {
        this.$emit("showSpinner");
        AuthApi.putApi(`${Env.giftcard_url}/api/card_category/` + this.updateForm.id, this.updateForm)
        .then(() => {
          this.updateDialog = false;
          this.init();
          this.$emit('hideSpinner');
          this.snackbar({
            text: 'Successfully updated.',
            timeout: 5000,
            open: true
          })
        })
        .catch(err => {
          this.$emit('hideSpinner');
          this.snackbar({
            text: err.response.data.payload.message,
            timeout: 5000,
            open: true
          })
        });
      }
    },

    /**
     *  To close update dialog box
     * @function
     * @returns {undefined}
     */
    closeUpdateDialog() {
      this.updateDialog = false;
      for (let key in this.updateForm) {
        this.updateForm[key] = "";
      }
    },

    /**
     *  To delete the category, it accepts an object which has ID to remove
     * @function
     * @returns {undefined}
     */
    deleteCardCategory(obj) {
      this.$emit("showSpinner");
      AuthApi.deleteApi(`${Env.giftcard_url}/api/card_category/` + obj.id)
      .then(() => {
        this.init();
        this.snackbar({
          text: 'Successfully deleted.',
          timeout: 5000,
          open: true
        })
        this.$emit("hideSpinner");
      })
      .catch(err => {
        this.snackbar({
          text: err.response.data.payload.message,
          timeout: 5000,
          open: true
        })
        this.$emit("hideSpinner");
      });
    },

    /**
     *  To filter the items depending on given parameters
     * @function
     * @returns {undefined}
     */
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      cf.registerFilter('name', (searchWord, innerItems) => {
        if (searchWord.trim() === '') return innerItems;
        return innerItems.filter((item) => { return item.name.toLowerCase().includes(searchWord.toLowerCase()); }, searchWord);
      });
      cf.registerFilter('occasion_id', (occasionid, innerItems) => {
        if (occasionid === '') return innerItems;
        return innerItems.filter((item) => { return item.occasion_id === occasionid; }, occasionid);
      });
      return cf.runFilters();
    },

    /**
     *  To filter the items by Name
     * @function
     * @returns {undefined}
     */
    filterByName(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        name: val,
      });
    },

    /**
     *  To filter the items by Occasion ID
     * @function
     * @returns {undefined}
     */
    filterByOccasion(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        occasion_id: val,
      });
    },

    /**
     *  To open modal for selecting / uploading image or resource
     * @function
     * @returns {undefined}
     */
    selectImage (str) {
      // Set the location where to fill in 
      this.$store.dispatch("SET_ATTACHMENT_LOCATION", str);
      // Open modal
      this.$store.dispatch("SET_ATTACHMENT_POPUP", true);
    },

    /**
   * To get occasion id and return name
   * @function
   * @returns {undefined}
   */
    changeOccasionIdtoName(id) {
      let catList = this.occasionList;
      var catName = null;
      catList.map((item) =>{
        if(item.value == id){
          catName = item.text;
        }
      });
      return catName;
    },

    /**
   * To get boolean and return string
   * @function
   * @returns {undefined}
   */
    changeBooltoStr(bol) {
      if(bol){
        return 'Published';
      } else {
         return 'Draft';
      }
    },
    ...mapActions({
      snackbar: 'snackbar/snackbar'
    }),
  },
};
</script>
<style scoped>
.list-img {
  width: 58px;
  height: auto;
  vertical-align: middle;
}
.image{
  padding-top:0px !important;
}
.image img{
    position: relative !important;
    width: 100px;
    height: auto;
}
</style>
